// Controlled Super Admin color coding. green active · amber onboarding/attention · red restricted · purple internal · gray inactive.
export const HEALTH = {
  active: { label: "Active", badge: "bg-emerald-500/15 text-emerald-700 border-emerald-500/30", dot: "bg-emerald-500", ring: "border-l-emerald-500" },
  attention: { label: "Needs Attention", badge: "bg-amber-500/15 text-amber-700 border-amber-500/30", dot: "bg-amber-500", ring: "border-l-amber-500" },
  restricted: { label: "Restricted", badge: "bg-rose-500/15 text-rose-700 border-rose-500/30", dot: "bg-rose-500", ring: "border-l-rose-500" },
  internal: { label: "Internal", badge: "bg-purple-500/15 text-purple-700 border-purple-500/30", dot: "bg-purple-500", ring: "border-l-purple-500" },
  inactive: { label: "Inactive", badge: "bg-slate-500/15 text-slate-600 border-slate-500/30", dot: "bg-slate-400", ring: "border-l-slate-400" },
};
export const healthOf = (k) => HEALTH[k] || HEALTH.inactive;

export const ACCOUNT_TYPE = {
  customer: { label: "Customer", cls: "" },
  internal_test: { label: "Internal Live Test", cls: "bg-purple-500/15 text-purple-700 border-purple-500/40 font-bold" },
  sandbox: { label: "Sandbox", cls: "bg-amber-400 text-amber-950 border-amber-500/60 font-extrabold" },
};

export const BILLING_METHOD = {
  stripe: { label: "Stripe Subscription", short: "Stripe", cls: "bg-violet-500/10 text-violet-700 border-violet-500/30" },
  manual: { label: "Manual / NEEC Managed", short: "Manual", cls: "bg-sky-500/10 text-sky-700 border-sky-500/30" },
};

export const LIFECYCLE_HELP = {
  onboarding: "Account provisioned; owner setting up. No payment expected yet.",
  trialing: "Free evaluation period. Moves to Awaiting Payment when the trial ends.",
  awaiting_payment: "Setup complete or trial ended; first payment not yet received.",
  active: "Billing entitlement is current. Full access.",
  past_due: "A payment failed or is late. Access continues during the grace period.",
  suspended: "Grace period ended. Only Billing, Support and Logout remain available.",
  cancelled: "Access cancelled. Data is retained; Stripe history preserved.",
};
